import { Button } from '@/components/ui/button';
import {
	Card,
	CardHeader,
	CardTitle,
	CardContent,
	CardDescription,
} from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConfettiExplosion from 'react-confetti-explosion';

const Validated = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	return (
		<Card className="mx-auto -mt-9 max-w-sm self-center">
			<CardHeader>
				<CardTitle className="text-xl">
					{t('validated.title')}
				</CardTitle>
				<ConfettiExplosion
					className="absolute left-1/2 top-1/3"
					particleCount={200}
					force={0.7}
				/>
			</CardHeader>
			<CardContent>
				<CardDescription>{t('validated.description')}</CardDescription>
				<Button
					className="mt-4 w-full"
					onClick={() => {
						navigate('/');
					}}
				>
					{t('validated.button')}
				</Button>
			</CardContent>
		</Card>
	);
};
export default Validated;
